import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(3, 1fr);\n\n  button {\n    width: 64px;\n  }\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  padding: 40px 10px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 210px;\n  background-color: ",
        ";\n  align-items: center;\n  justify-content: center;\n\n  a {\n    width: 180px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
import styled, { useTheme } from "styled-components";
import { styled as muiStyled, Typography } from "@mui/material";
import Coupon from "@/components/Coupons/Coupon";
import { postUserCoupon } from "../../../api/coupon";
import dayjs from "dayjs";
import FilledLink from "@/components/common/Link/FilledLink";
import { MYPAGE_COUPONS } from "@/settings/constant";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSnackbar, { defaultSnackbarProps, IconWithSnackbarMessage, Snackbar } from "@/components/common/Snackbar/index";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { LoginModal } from "@/components/common/modal/LoginModal";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
const snackbarVariants = {
    success: {
        icon: "success",
        text: "쿠폰이 발급됐어요."
    },
    warning: {
        icon: "warning",
        text: "쿠폰 정보가 존재하지 않아요."
    }
};
export const CouponListSection = (param)=>{
    let { data , category  } = param;
    const { isLoggedIn  } = useAuthStore();
    const queryClient = useQueryClient();
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const { isShowSnackbar , showSnackbar , hideSnackbar , snackbarMessage  } = useSnackbar(snackbarVariants);
    const usePostUserCouponMutation = useMutation(postUserCoupon, {
        onSuccess: (data)=>{
            queryClient.invalidateQueries([
                "receivableCouponList"
            ]);
            queryClient.invalidateQueries([
                "couponFilter"
            ]);
            showSnackbar("success");
            mixpanelEvent("Coupon Issued", {
                CouponId: data.couponId,
                CouponTitle: data.name
            });
        },
        onError: (error)=>{
            ;
            showSnackbar("warning");
        }
    });
    const onHandleClick = (couponId)=>{
        if (!isLoggedIn) {
            setIsLoginModalOpen(true);
            return;
        }
        usePostUserCouponMutation.mutate(couponId);
    };
    const decodedCategory = decodeURIComponent(category);
    return /*#__PURE__*/ _jsxs(CouponListSectionContainer, {
        role: "list",
        children: [
            /*#__PURE__*/ _jsxs(CountTitle, {
                children: [
                    decodedCategory,
                    " ",
                    /*#__PURE__*/ _jsxs("em", {
                        children: [
                            data.count,
                            "개"
                        ]
                    })
                ]
            }),
            data.count > 0 ? /*#__PURE__*/ _jsx(CouponList, {
                children: data.items.map((coupon, idx)=>{
                    return /*#__PURE__*/ _jsx(CouponListItem, {
                        coupon: coupon,
                        onHandleClick: onHandleClick
                    }, idx);
                })
            }) : /*#__PURE__*/ _jsx(EmptyCouponList, {}),
            /*#__PURE__*/ _jsx(Snackbar, {
                ...defaultSnackbarProps,
                open: isShowSnackbar,
                onClose: hideSnackbar,
                message: /*#__PURE__*/ _jsx(IconWithSnackbarMessage, {
                    ...snackbarMessage
                })
            }),
            /*#__PURE__*/ _jsx(LoginModal, {
                isOpen: isLoginModalOpen,
                close: ()=>setIsLoginModalOpen(false)
            })
        ]
    });
};
const CouponListItem = (param)=>{
    let { coupon , onHandleClick  } = param;
    const renderExpiredText = useCallback((param)=>{
        let { expiredAfterDay , expiredDate  } = param;
        if (expiredAfterDay) return "받기 후 ".concat(expiredAfterDay, "일간 사용가능");
        if (expiredDate) return "".concat(dayjs(expiredDate).format("YYYY.MM.DD"), "까지");
    }, []);
    return /*#__PURE__*/ _jsxs(Coupon, {
        children: [
            /*#__PURE__*/ _jsxs(Coupon.Content, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Coupon.Title, {
                                children: coupon.title
                            }),
                            coupon.discountMaximumPriceText && /*#__PURE__*/ _jsx(Coupon.MaxDiscount, {
                                children: coupon.discountMaximumPriceText
                            }),
                            coupon.minimumPriceText && /*#__PURE__*/ _jsx(Coupon.Condition, {
                                children: coupon.minimumPriceText
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Coupon.ExpireDate, {
                        children: renderExpiredText({
                            expiredDate: coupon.expiredDate,
                            expiredAfterDay: coupon.expiredAfterDay
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Coupon.Possession, {
                status: false,
                onHandleClick: ()=>onHandleClick(coupon.id)
            })
        ]
    }, coupon.id);
};
const EmptyCouponList = ()=>{
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(EmptyCouponContainer, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                typography: "regular16",
                color: theme.new.colors.sol_gray_500,
                children: "쿠폰을 모두 받았어요!"
            }),
            /*#__PURE__*/ _jsx(FilledLink, {
                type: "text",
                variant: "solid",
                href: MYPAGE_COUPONS,
                onClick: ()=>{
                    mixpanelEvent("My Coupon Button Clicked");
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    typography: "semibold14",
                    color: theme.new.colors.white,
                    children: "내 쿠폰 보기"
                })
            })
        ]
    });
};
const CouponListSectionContainer = styled.div.withConfig({
    componentId: "sc-457c85b0-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_mint_300);
const CountTitle = muiStyled("p")((param)=>{
    let { theme  } = param;
    return {
        ...theme.typography.semibold16,
        em: {
            color: theme.palette.blue[400],
            marginLeft: 4
        }
    };
});
const CouponList = styled.ul.withConfig({
    componentId: "sc-457c85b0-1"
})(_templateObject1());
const EmptyCouponContainer = styled.div.withConfig({
    componentId: "sc-457c85b0-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_0);
